module.exports = __webpack_public_path__ + "static/media/slide7.81bb8042.png";